import { SHIPMENT } from "MODULES/Receiving/constants";

export const CANCELLATION_REASONS = [
  { value: "previously_sold", text: "Previously Sold" },
  { value: "part_deemed_ber", text: "Part Deemed B.E.R" },
  { value: "vendor_cant_find", text: "Vendor Can't Find" },
  { value: "unethical_behavior_detected", text: "Unethical Behavior Detected" },
  { value: "cancelled_by_tenant", text: "Cancelled by Us" },
  { value: "unknown", text: "Unknown" }
];

export const CONSIGNMENT = "consignment";
export const SO_ITEM = "sales_order_line_item";
export const RO_ITEM = "repair_order_line_item";
export const PO_ITEM = "purchase_order_line_item";
export const TRANSFER = "inventory_transfer_order";
export const MRO_ITEM = "managed_repair_order_line_item";
export const REJECTED_CORE_ORDER = "rejected_core_order";
export const RETURNED_CONSIGNMENT = "returned_consignment";
export const RETURNED_CORE = "returned_core";
export const RETURN_TO_CUSTOMER_RECORD = "return_to_customer_record";
export const INVENTORY_TRANSFER_ORDER = "inventory_transfer_order";
export const RMA = "rma";
export const MISTAKE = "mistake_shipment";

export const LINE_ITEM_TYPES = {
  [PO_ITEM]: {
    abbrev: "PO"
  },
  [MISTAKE]: {
    abbrev: "MS"
  },
  [MRO_ITEM]: {
    abbrev: "MR"
  },
  [RETURNED_CONSIGNMENT]: {
    abbrev: "RC"
  },
  [RETURNED_CORE]: {
    abbrev: "RCORE"
  },
  [SO_ITEM]: {
    abbrev: "SO"
  },
  [RO_ITEM]: {
    abbrev: "RO"
  },
  [TRANSFER]: {
    abbrev: "TR"
  },
  [RMA]: {
    abbrev: "RMA"
  },
  [REJECTED_CORE_ORDER]: {
    abbrev: "SO"
  },
  [SHIPMENT]: {
    abbrev: "S"
  }
};

export const itemInfo = t => LINE_ITEM_TYPES[t] || {};

export const ATTACHMENT_TYPES = {
  placeholder_one: {
    label: "Placeholder One"
  },
  placeholder_two: {
    label: "Placeholder Two"
  },
  placeholder_three: {
    label: "Placeholder Three"
  }
};



// WEBPACK FOOTER //
// ./app/modules/Orders/shared/constants.js